export default "__VITE_ASSET__Ban9id_q__"